import { GetterTree } from 'vuex'
import { CategoryModule } from '..'
import { categoryToFilterSets, populateReferences } from './category.helpers'
import { PopulatedCategory, BBTreeviewNode } from '../../types'

export const getters: GetterTree<typeof CategoryModule['state'], unknown> = {
  populatedCategories(state): Array<PopulatedCategory> {
    return populateReferences(state.all)
  },
  categoriesAsTreeNodes(_state, getters): BBTreeviewNode {
    return {
      name: 'Category',
      id: 'all_categories',
      groupingKey: 'category',
      type: 'Checkbox',
      children: [
        ...categoryToFilterSets(getters.populatedCategories),
        { id: 'category_not_set', name: 'Not Set', value: null, groupingKey: 'category', type: 'Checkbox' }
      ]
    }
  }
}
